/* eslint-disable react/jsx-pascal-case */
import Profile_Customize_BackgroundColor_Button from "./Profile_Customize_BackgroundColor_Button";
import {connect} from "react-redux";

const Profile_Customize_BackgroundColor = (props) => {
    const colors = ["Default", "Dim", "Dark"];
    
    return(
        <div className="profile_customize_section">
            <h3 className="profile_customize_section_heading">Background</h3>
            <div className={`profile_customize_section_main  background_change_${props.color_background}`}>
                {
                    colors.map((color,i) => {
                        return <Profile_Customize_BackgroundColor_Button 
                            key={i} 
                            color={color} 
                        />
                    })
                }
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        color_background: state.getColorBackground.color_background
    }
}
export default connect(mapStateToProps)(Profile_Customize_BackgroundColor);